export const trackSubscribeEmail = (isEip) => ({
    event: 'opt_in',
    opt_position: `email preference${isEip ? ' eip' : ''}`,
    opt_value: true,
})

export const trackUpdatePreferredCountryAndLanguage = (selectedOption) => ({
    event: 'update_email_preferences',
    selected_option: selectedOption,
})
